import { logButtonClick } from 'state/amplitude';
import { ClickEventComponentNames } from 'state/amplitude/constants';

export const logCartContinue = () => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      name: 'Continue in Cart',
    },
  });
};
export const logCartPlaceOrder = () => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      name: 'Place Secure Order',
    },
  });
};
export const logCartContinueOrder = () => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      name: 'Continue',
    },
  });
};
